<template>
  <modal
    name="bookmark-start-tour-modal"
    :adaptive="true"
    :classes="['bookmark-start-tour-modal']"
    :click-to-close="false"
    :height="'auto'"
    :scrollable="true"
    :width="540"
  >
    <button
      class="close"
      @click="hide()"
    >
      <icon
        name="cross"
        variant="b3b3b3"
      />
    </button>
    <h2 class="title">
      Since it is your first time here.
    </h2>
    <p
      v-if="showText"
      class="text"
    >
      Take a couple of minutes to check out a couple of beneficial new features.
    </p>
    <div class="tour-preview">
      <img
        src="../../assets/images/search-pulse-graphic.svg"
        role="presentation"
        alt=""
      >
      <p>Search for topics of interest.</p>
    </div>
    <div class="tour-preview">
      <img
        src="../../assets/images/empty-bookmark-textbook.svg"
        role="presentation"
        alt=""
      >
      <p>Bookmark topics for quick access.</p>
    </div>
    <button
      class="start-button"
      @click="triggerStart()"
    >
      Get Started
    </button>
  </modal>
</template>

<script>
import Icon from '@components/singletons/icon';

import { startTour } from '@/utils/tour';

export default {
  components: { Icon },
  computed: {
    showText() {
      return this.$store.getters['session/userClass'] === 'nurse_rn';
    },
  },
  methods: {
    hide() {
      this.$store.commit('session/scheduleTour', false);
      this.$modal.hide('bookmark-start-tour-modal');
    },
    triggerStart() {
      startTour.apply(this);
    },
  },
};
</script>

<style lang='scss'>
  .bookmark-start-tour-modal {
    background-color: #001c74;
    border-radius: rem-calc(6);
    padding: rem-calc(32);
    position: relative;
    text-align: center;

    @include breakpoint(small) {
      max-width: 98%;
      margin-left: 1%;
      padding: rem-calc(16) rem-calc(16);
    }

    .title {
      font-size: rem-calc(32);
      line-height: 1.35;
      margin: 0 auto rem-calc(24) auto;
      max-width: rem-calc(320);
      color: #ffffff;
    }

    .text {
      font-size: rem-calc(16);
      color: #ffffff;
      line-height: 1.25;
      max-width: rem-calc(320);
      margin: 0 auto rem-calc(24);

      @include breakpoint(small) {
        margin-bottom: rem-calc(40);
      }
    }

    .tour-preview {
      height: rem-calc(200);
      width: rem-calc(200);
      display: inline-block;
      margin: 0 rem-calc(4);
      vertical-align: top;

      @include breakpoint(small) {
        height: rem-calc(220);
        width: 40%;
        min-width: rem-calc(128);
      }

      img {
        width: auto;
        height: rem-calc(100);
        border-radius: rem-calc(8) rem-calc(8) 0 0;
        margin-top: rem-calc(32);

        @include breakpoint(small) {
          height: rem-calc(80);
        }
      }

      p {
        color: #ffffff;
        font-weight: $semi-bold;
        line-height: 1.25;
        margin-top: rem-calc(24);
        padding: 0 rem-calc(8);

        @include breakpoint(small) {
          margin-top: rem-calc(12);
          margin-bottom: rem-calc(12);
        }
      }
    }

    .start-button {
      background-color: #00d8f8;
      border-radius: rem-calc(24);
      color: #ffffff;
      width: rem-calc(200);
      font-size: rem-calc(16);
      font-weight: $semi-bold;
      margin: rem-calc(58) auto rem-calc(8);
      padding: rem-calc(15) rem-calc(24);
      display: block;

      @include breakpoint(small) {
        margin-top: rem-calc(40);
      }
    }

    .close {
      right: rem-calc(6);
      position: absolute;
      top: rem-calc(6);
      background: transparent;
      border: none;
      padding: 0;
      opacity: 0.4;

      @include breakpoint(small) {
        right: rem-calc(4);
      }

      img {
        height: rem-calc(16);
        width: rem-calc(16);

        @include breakpoint(small) {
          height: rem-calc(20);
          width: rem-calc(20);
        }
      }
    }
  }
</style>
